import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

interface RaceMetaDataWrapperPropsType {
    isFinishedRace: boolean;
}

export const RaceMetaDataWrapper = withConfig(theme => styled('div', { label: 'RaceMetaDataWrapper' })<RaceMetaDataWrapperPropsType>`
    color: ${({ isFinishedRace }): string => isFinishedRace ? theme.star.raceCard.stats.txtColor : theme.star.raceCard.details.txtColor};
    display: flex;
    flex-flow: row wrap;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.regular};
    line-height: 1.3334;
    margin-top: 16px;
`);
